export default __webpack_public_path__ + "static/media/trophy.75bd4409.svg";